<template>
    <transition name="fade" mode="out-in">
        <div v-if="isOpen" class="popup-rodo-information">
            <button
                type="button"
                class="popup-rodo-information__close-popup"
                @click="closePopup"
            />
            <div class="popup-rodo-information__content">
                <div class="popup-rodo-information__row">
                    <p>
                        {{ $t(`${TRANSLATION_KEY}.paragraphOneContent`) }}
                    </p>
                    <button
                        type="button"
                        class="button button--submit"
                        @click="handleRedirect"
                    >
                        {{ $t(`${TRANSLATION_KEY}.next`) }}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue';

export default defineComponent({
    name: 'UkraineResidenceInfo',
    props: {
        isOpen: Boolean,
    },
    emits: ['close'],
    setup(props, { emit }) {
        const { isOpen } = toRefs(props);
        const TRANSLATION_KEY = 'UkraineResidenceInfo';

        const handleRedirect = () => {
            window.location.replace('https://www.oanda.com/apply/');
        };

        const closePopup = () => {
            emit('close');
        };

        return {
            isOpen,
            TRANSLATION_KEY,
            handleRedirect,
            closePopup,
        };
    },
});
</script>
